// @ts-ignore
import { CSSProperties, useEffect, useState } from "react";
import { createPortal } from "react-dom";
import styles from "./ugcModal.component.module.scss";
import Image from "next/image";
import CloseIcon from "../../../../shared-assets/images/funUgc/modal/CloseIcon.png";
import NextIcon from "../../../../shared-assets/images/funUgc/modal/LeftIcon.png";
import PreviousIcon from "../../../../shared-assets/images/funUgc/modal/RightIcon.png";
import useWindowWidth from "../../../services/window-width-hook";
import { useRouter } from "next/router";

export interface ModalProps {
  onClose: () => void;
  onPrevious: () => void;
  onNext: () => void;
}

interface ComponentUgcModalProps extends ModalProps {
  children: any;
  overlayStyle?: CSSProperties;
  modalStyle?: CSSProperties;
  bodyStyle?: CSSProperties;
  hasCloseBtn?: boolean;
  title?: string;
}

function UgcModal({
  children,
  overlayStyle,
  modalStyle,
  bodyStyle,
  hasCloseBtn,
  title,
  onClose,
  onPrevious,
  onNext
}: ComponentUgcModalProps) {
  const [isBrowser, setIsBrowser] = useState(false);
  const { isMobile } = useWindowWidth();
  const router = useRouter();

  useEffect(() => {
    setIsBrowser(true);
  }, []);

  const handleCloseModal = () => {
    if (router.asPath !== "/") {
      router.replace({
        pathname: router.pathname,
        query: {}
      });
    }

    onClose();
  };
  const modalContent = (
    <div style={overlayStyle} className={styles.overlay}>
      {title && <div className={styles.titleTxt}>{title}</div>}

      {hasCloseBtn && (
        <div className={styles.closeWrapper} onClick={handleCloseModal}>
          <div className={styles.close}>
            <Image src={CloseIcon} alt="بستن" layout="fill" priority={true} />
          </div>
        </div>
      )}

      <div
        style={modalStyle}
        className={styles.modal}
        onClick={e => e.stopPropagation()}
      >
        {!isMobile && hasCloseBtn && (
          <div className={styles.previousWrapper} onClick={() => onPrevious()}>
            <div className={styles.previous}>
              <Image
                src={PreviousIcon}
                alt="قبلی"
                layout="fill"
                priority={true}
              />
            </div>
          </div>
        )}

        {!isMobile && hasCloseBtn && (
          <div className={styles.nextWrapper} onClick={() => onNext()}>
            <div className={styles.next}>
              <Image src={NextIcon} alt="بعدی" layout="fill" priority={true} />
            </div>
          </div>
        )}

        <div style={bodyStyle} className={styles.body}>
          <div className={styles.children}>{children}</div>
        </div>
      </div>
    </div>
  );

  if (isBrowser) {
    return createPortal(
      modalContent,
      document.getElementById("modal-root") as Element
    );
  } else {
    return null;
  }
}

export default UgcModal;
